const handleNav = () => {
	const $navTrigger = $('.js-nav-trigger');
	const $navContainer = $('.js-nav-container');

	$navTrigger.on('click', (event) => {
		event.preventDefault();

		$navTrigger.toggleClass('nav-trigger--active');
		$navContainer.toggleClass('is-active');
		$('.js-header-search').slideUp();
	})
};

handleNav();
